import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../lib/supabase';

export function RefLandingPage() {
  const { code }        = useParams<{ code: string }>();
  const navigate        = useNavigate();
  const [name, setName] = useState('Alguém especial');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!code) { navigate('/register'); return; }
    sessionStorage.setItem('referral_code', code);
    lookupReferrer();
    trackAffiliateClick(code);
  }, [code]);

  async function lookupReferrer() {
    const { data } = await supabase
      .from('referrals')
      .select('profiles:referrer_id(full_name)')
      .eq('referral_code', code)
      .maybeSingle();

    const fullName = (data?.profiles as unknown as { full_name?: string } | null)?.full_name;
    if (fullName) setName(fullName.split(' ')[0]);
    setReady(true);
  }

  async function trackAffiliateClick(affiliateCode: string) {
    try {
      const params      = new URLSearchParams(window.location.search);
      const ua          = navigator.userAgent;
      const deviceType  = /Mobi|Android/i.test(ua) ? 'mobile' : 'desktop';
      const browser     = ua.includes('Edg') ? 'edge'
                        : ua.includes('Chrome') ? 'chrome'
                        : ua.includes('Firefox') ? 'firefox'
                        : ua.includes('Safari') ? 'safari' : 'other';

      const { data } = await supabase.functions.invoke('track-referral-click', {
        body: {
          affiliateCode,
          utmSource:   params.get('utm_source')   ?? undefined,
          utmMedium:   params.get('utm_medium')   ?? undefined,
          utmCampaign: params.get('utm_campaign') ?? undefined,
          utmContent:  params.get('utm_content')  ?? undefined,
          utmTerm:     params.get('utm_term')     ?? undefined,
          deviceType,
          browser,
          landingPage: window.location.href,
          referrer:    document.referrer || undefined,
        },
      });

      if (data?.data?.clickId) {
        localStorage.setItem('affiliate_click_id', data.data.clickId);
        localStorage.setItem('affiliate_code', affiliateCode);
      }
    } catch {
      // fire-and-forget, don't block page
    }
  }

  return (
    <>
    <Helmet>
      <title>{name !== 'Alguém especial' ? `${name} te presenteou com 30 dias no Professya` : 'Você foi convidado para o Professya'}</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-base)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ textAlign: 'center', maxWidth: '420px', width: '100%' }}>
        <span style={{ fontSize: '3.5rem', display: 'block', marginBottom: '1.25rem' }}>💫</span>

        {ready && (
          <>
            <h1 className="font-display" style={{ fontSize: 'clamp(1.25rem,4vw,1.875rem)', color: 'var(--text-primary)', marginBottom: '1rem', lineHeight: 1.3 }}>
              {name} presenteou você com 30 dias grátis.
            </h1>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', marginBottom: '1.5rem', lineHeight: 1.6 }}>
              Crie sua conta para ativar seu presente e descobrir o que os astros têm a dizer sobre você.
            </p>

            <div style={{ padding: '1rem', backgroundColor: 'rgba(31,78,95,0.06)', border: '1px solid var(--border-gold)', borderRadius: 'var(--radius-md)', marginBottom: '1.5rem' }}>
              <p style={{ color: 'var(--petrol)', fontSize: 'var(--text-label)', fontWeight: 600, margin: '0 0 0.25rem' }}>
                🎁 Seu presente
              </p>
              <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-caption)', margin: 0 }}>
                30 dias de acesso completo ao Professya Pro
              </p>
            </div>

            <button className="btn btn-primary btn-block" onClick={() => navigate('/register')}>
              Criar minha conta grátis ✦
            </button>

            <p style={{ color: 'var(--text-muted)', fontSize: 'var(--text-caption)', marginTop: '1rem' }}>
              Já tem conta? <button className="btn btn-ghost btn-sm" onClick={() => navigate('/login')} style={{ display: 'inline', padding: '0 0.25rem' }}>Faça login →</button>
            </p>
          </>
        )}

        {!ready && (
          <p style={{ color: 'var(--text-secondary)', fontStyle: 'italic' }}>Verificando convite...</p>
        )}
      </div>
    </div>
    </>
  );
}
